// extracted by mini-css-extract-plugin
export default {"host":"SecondaryButton_host__TZrRi"};